import React, { useState } from 'react'
import logo from '../assets/logo.png'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CallMadeIcon from '@mui/icons-material/CallMade';




export default function Header() {
    
    const [open, setOpen] = useState(false);
    const [sidemenuopen, setSidemenuopen] = useState(false);
   
    return (
        <>
            <header className="w-full  text-black bg-white shadow-md sticky top-0 z-50 ">
                <div className="mx-auto flex items-center justify-between">

                    {/* Logo */}
                    <Link to='/'><img src={logo} alt="Logo" style={{ width: '250px', paddingLeft:'35px' }} /></Link>

                  
                     <nav className="hidden lg:flex space-x-6 px-5 " style={{ alignItems: 'center' }}>
                        <Link to='/' className=" text-base font-medium  hover:text-cyan-500">Home</Link>
                        <Link to={'/about-us'} className="text-base font-medium   hover:text-cyan-500">About Us</Link>
                         <Link to={'/services'} className="text-base font-medium   hover:text-cyan-500"> Our Services</Link>
                       
                      
                      
                        <Link to={'/contact-us'} className="text-base font-medium hover:text-cyan-500">Contact Us</Link>

                        <div className='align-items-center flex'>
                            <Link to={'/pay-now'}>
                            <button className="ms-bg-primary text-white px-4 py-2 rounded-[10px] text-lg">
                                Repay-Loan <ArrowOutwardIcon />
                            </button> &nbsp; 
                            </Link>

                            <Link to={'/apply-now'}>
                             <button className="ms-bg-secondary text-white px-4 py-2 rounded-[10px] text-lg">
                                Apply Now <ArrowOutwardIcon />
                            </button>
                            </Link>

                        </div>

                       


                    </nav>

                 
                    <button
                        onClick={() => setOpen(!open)}
                        className="lg:hidden focus:outline-none px-4"
                    >
                        <svg
                            className="w-8 h-8"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            {open ? (
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            ) : (
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            )}
                        </svg>
                    </button>
                </div>

               
                {open && (
                    <nav className="lg:hidden bg-gray-700 px-4 pb-4 space-y-2 text-white">
                        <Link to='/' className="block py-2 hover:text-red-400">Home</Link>
                        <Link to={'/about-us'} className="block py-2">About Us</Link>
                        <Link to={'/services'} className="block py-2">Our Services</Link>
                        {/* <Link href="#" className="block py-2">Source City</Link> */}
                        {/* <Link href="#" className="block py-2">Blog</Link> */}
                        <Link to={'/pay-now'} className="block py-2">Repay-Loan</Link>
                        <Link to={'/contact-us'} className="block py-2">Contact Us</Link>
                    </nav>

                )}
            </header>


        </>
    )
}
